import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const popupContainer = css`
  ${flex('column')};
  padding: 10px;
  ${MQ.MediaMd} {
    ${flex('column', 'center', 'flex-start')};
  }
`;

export const yesButtonStyle = css`
  border: 1px solid ${colors.PurpleBtn};
  background: ${colors.white};
  height: 50px;
  margin: 10px 0px;
  width: 98%;
  color: ${colors.PurpleBtn};
  ${MQ.MediaSm} {
    width: 70%;
  }
  ${MQ.MediaMd} {
    width: 100%;
  }
`;

export const noButtonStyle = css`
  background: ${colors.PurpleBtn};
  color: ${colors.PrimaryWhiteColor};
  width: 350px;
  height: 50px;
  margin: 10px 0px;
  width: 98%;
  ${MQ.MediaSm} {
    width: 70%;
  }
  ${MQ.MediaMd} {
    width: 100%;
  }
`;

export const popupTitleStyle = css`
  padding: 25px 0px;
  ${ZeeFontBold(20, 22)};
`;

export const popupDescStyle = css`
  ${ZeeFontRegular(12, 14)};
  color: ${colors.PrimaryWhiteColorAlpha};
  text-align: center;
  ${MQ.MediaMd} {
    text-align: left;
  }
`;
